import React from 'react';

const SelectInputNarrow = function({children,value,change,disabled,...props}) {
    return (
      <select value={value} onChange={change} className="select-input-narrow" disabled={disabled ? true : false}>
          {children}
      </select>
    );
}

export default SelectInputNarrow;
